export enum RequestType {
	donation = 'Donation',
	sponsoring = 'Sponsoring',
}
